import { __decorate } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { BrMaskerModule } from 'br-mask';
import { TooltipModule } from 'ng2-tooltip-directive';
import { NgxMaskIonicModule } from 'ngx-mask-ionic';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { UiCButtonModule } from '@wlp/ui-c-button';

let UiCProsperaAttendanceComponent = class UiCProsperaAttendanceComponent {
    constructor() {
        this.continue = new EventEmitter();
    }
    f(control) {
        return this.form.get(control);
    }
    onContinue() {
        this.continue.emit(this.form);
    }
};
__decorate([
    Input()
], UiCProsperaAttendanceComponent.prototype, "list", void 0);
__decorate([
    Input()
], UiCProsperaAttendanceComponent.prototype, "form", void 0);
__decorate([
    Input()
], UiCProsperaAttendanceComponent.prototype, "errorMessages", void 0);
__decorate([
    Output()
], UiCProsperaAttendanceComponent.prototype, "continue", void 0);
UiCProsperaAttendanceComponent = __decorate([
    Component({
        selector: 'ui-c-prospera-attendance',
        template: "<form class=\"faq-form\" [formGroup]=\"form\">\n  <ion-row>\n    <div class=\"details\">\n      <ion-row>\n        <ion-col size=\"12\">\n          <div class=\"detail-item\">\n            <ion-text class=\"ion-text-center\">\n              <p class=\"ion-margin margin-bottom-and-top-30 font-color2\">\n                {{'PROSPERA.ATTENDANCE.SUBTITLE.PART_1'| wlpTranslate}} <br>\n                {{'PROSPERA.ATTENDANCE.SUBTITLE.PART_2'| wlpTranslate}} <br>\n                {{'PROSPERA.ATTENDANCE.SUBTITLE.PART_3'| wlpTranslate}}\n              </p>\n            </ion-text>\n            <ion-list>\n              <ion-item>\n                <ion-label class=\"font-family-semibold\">\n                  {{'PROSPERA.ATTENDANCE.FORM.INPUT.SUBJECT.LABEL'| wlpTranslate}}\n                </ion-label>\n                <ion-select\n                  cancel-text=\"Cancelar\"\n                  formControlName=\"subject\"\n                  [ngClass]=\"{\n                          'is-invalid': f('subject').invalid && f('subject').touched,\n                          'is-valid': f('subject').valid\n                        }\"\n                >\n                  <ion-select-option\n                    *ngFor=\"let item of list\"\n                    [value]=\"item.title\">\n                    {{ item.title }}\n                  </ion-select-option>\n                </ion-select>\n              </ion-item>\n              <div class=\"error-messages\">\n                <ng-container *ngFor=\"let error of errorMessages.subject\">\n                  <div class=\"error-message\"\n                       *ngIf=\"form.get('subject').hasError(error.type) && (form.get('subject').dirty || form.get('subject').touched)\">\n                    {{error.message | wlpTranslate: error?.param}}\n                  </div>\n                </ng-container>\n              </div>\n            </ion-list>\n          </div>\n        </ion-col>\n      </ion-row>\n      <ion-row class=\"ion-justify-content-center ion-align-items-center\">\n        <ion-col size=\"12\">\n          <ion-item>\n            <ion-textarea (input)=\"$event.target.value = $event.target.value.toUpperCase()\" \n              placeholder=\"Descri\u00E7\u00E3o\"\n              autocomplete=\"on\"\n              autocorrect=\"on\"\n              rows=\"5\"\n              formControlName=\"message\"\n              [ngClass]=\"{\n                          'is-invalid': f('message').invalid && f('message').touched,\n                          'is-valid': f('message').valid\n                        }\"\n              ></ion-textarea>\n          </ion-item>\n          <div class=\"error-messages\">\n            <ng-container *ngFor=\"let error of errorMessages.message\">\n              <div class=\"error-message\"\n                   *ngIf=\"form.get('message').hasError(error.type) && (form.get('message').dirty || form.get('message').touched)\">\n                {{error.message | wlpTranslate: error?.param}}\n              </div>\n            </ng-container>\n          </div>\n        </ion-col>\n      </ion-row>\n      <ion-row class=\"ion-justify-content-center\">\n        <ion-col class=\"ion-padding\" [size]=\"12\">\n          <div class=\"col-button\">\n            <ui-c-button expand=\"block\" (continue)=\"onContinue()\" [disabled]=\"!form.valid\">\n              {{'PROSPERA.ATTENDANCE.BUTTON.TITLE' | wlpTranslate}}\n            </ui-c-button>\n          </div>\n        </ion-col>\n      </ion-row>\n    </div>\n  </ion-row>\n</form>\n",
        styles: [""]
    })
], UiCProsperaAttendanceComponent);

let UiCProsperaAttendanceModule = class UiCProsperaAttendanceModule {
};
UiCProsperaAttendanceModule = __decorate([
    NgModule({
        declarations: [UiCProsperaAttendanceComponent],
        imports: [
            CommonModule,
            IonicModule,
            ReactiveFormsModule,
            NgxMaskIonicModule,
            TooltipModule,
            BrMaskerModule,
            UiBsTranslateModule,
            UiCButtonModule,
        ],
        exports: [UiCProsperaAttendanceComponent]
    })
], UiCProsperaAttendanceModule);

/*
 * Public API Surface of ui-c-prospera-attendance
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCProsperaAttendanceComponent, UiCProsperaAttendanceModule };
//# sourceMappingURL=wlp-ui-c-prospera-attendance.js.map
